module.exports = __webpack_public_path__ + "img/_DSC7469-mobileVersion-min.2e944cff.jpg";